import React from 'react';

import { Button, Icons, createClasses } from '@kp/react-ui';

const classes = createClasses({
  root: {
    textDecoration: 'none',
  },
});

export interface OpenAppButtonProps {
  label: string;
  /** Required unless `loading`; the button only links once it is known. */
  url?: string;
  variant?: 'primary' | 'secondary';
  /**
   * Shows a busy button in place of the link. The spinner takes the open-in
   * icon's slot, so the button keeps its width when the url arrives.
   */
  loading?: boolean;
}

export const OpenAppButton: React.FC<OpenAppButtonProps> = ({
  label,
  url,
  variant = 'secondary',
  loading = false,
}) =>
  loading ? (
    <Button variant={variant} rightIcon={Icons.IconOpenIn} loading>
      {label}
    </Button>
  ) : (
    <Button
      component="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      variant={variant}
      rightIcon={Icons.IconOpenIn}
      className={classes.root}
    >
      {label}
    </Button>
  );
